export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7251.c139426a.jpg";